import React from "react";
import { FileText } from "lucide-react";

export default function QuestionBox({
  question,
  eyebrow = "Prompt",
  title = "Read the text below",
  scrollable = true,
}) {
  return (
    <section className="w-full overflow-hidden rounded-md border border-slate-200 bg-white shadow-sm">
      <div className="flex flex-col gap-3 border-b border-slate-100 bg-slate-50 p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-center gap-3">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md bg-white text-purple-700 shadow-sm">
          <FileText className="h-4 w-4" aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold uppercase text-purple-700">
            {eyebrow}
          </p>
          <h3 className="truncate text-lg font-extrabold text-gray-900">
            {title}
          </h3>
        </div>
      </div>
      </div>

      <div
        className={`w-full bg-white p-4 text-base leading-8 text-gray-700 sm:p-5 ${
          scrollable ? "max-h-[46vh] overflow-y-auto" : ""
        }`}
      >
        <p className="w-full max-w-none whitespace-pre-wrap break-words">
          {question || "Question text is loading..."}
        </p>
      </div>
    </section>
  );
}
